export const formValid = (data) => {
    let response = true
    Object.keys(data).forEach((key) => {
        if (data[key].validity == false) {
            response = false
        }
    })
    //console.log('form validity', response)
    return response
}